/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.controllers.module.ts" />
/// <reference path="../../common/iapirequestconfig.ts" />
/// <reference path="../modeleditorconfig.ts" />

module App.Common.Controllers {
    'use strict';

    export abstract class ModelEditorControllerBase<T> extends Controllers.ModalDialogControllerBase {

        public static $inject = ['$injector', '$uibModalInstance', 'config', 'modalConfig'];
        constructor(
            $injector: angular.auto.IInjectorService,
            $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
            public config: ModelEditorConfig<T>,
            modalConfig: ModalDialogConfig,
            $uibModalStack: angular.ui.bootstrap.IModalStackService
        ) {
            super($injector, $uibModalInstance, modalConfig, $uibModalStack);
        }



        public mainFormName() {
            return this.controllerName().replace('Controller', 'Form');
        }

    }

}